'use strict';

const allBrands = state => {
  return state.brands.slice();
};

export default {
  allBrands
};
